   /* eslint-disable */
 <template>
 <v-card>
     <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

    <v-card-title></v-card-title>
  <v-data-table
    :headers="headers"
    :items="profediscinas"
    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white" v-role="'func'">

        <v-toolbar-title class="hidden-sm-and-down">

           Ano Lectivo
           <v-col cols="12" sm="12" md="6">
                     <v-combobox
                        v-model="editedItem.classe"
                        item-value="idAnoLectivo"
                        item-text="descricao"
                         @change="initprofdisc(search)"
                        :items="ano"
                        chips
                        label="Ano Lectivo"
                      ></v-combobox>
                    </v-col>
        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  v-if="search"  @click="initprofdisc(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">
          <template v-slot:activator="{ on }" v-on="on">
           <!--   <v-btn class="mx-2" fab dark color="primary" v-on="on">

            <v-icon dark>add</v-icon>
            </v-btn>-->
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col v-if="false" cols="12" sm="12" md="6">

                      <v-text-field

                        v-model="editedItem.idFuncionario"
                        label="cod"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                   <v-overflow-btn

             v-model="editedItem.professor"
          :items="professores"
          label="Funcionário"
          editable

          item-value="idProfessor"
          item-text="nome"
        >      </v-overflow-btn>

                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                       <v-combobox
                        v-model="editedItem.curso"
                        item-value="idCurso"
                        item-text="descricao"
                          @change="loadTurmaComb"
                          @click="loadTurmaComb"
                        :items="cursos"
                        chips
                        label="Curso"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                     <v-combobox  id="turma"
                        v-model="editedItem.turma"
                        item-value="pkturma"
                        item-text="turmadescricao"
                         @change="loadDiscpilanComb"
                          @click="loadDiscpilanComb"
                        :items="turmasFiltered"
                        chips
                        label="Turma"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                         <v-combobox  id="turma"
                        v-model="editedItem.iddisciplina"
                        item-value="iddisciplina"
                        item-text="descricao"
                        :items="disciplinasFiltered"
                        chips
                        label="Disciplina"
                      ></v-combobox>

                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn v-if="!replace"
                color="blue darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save"
                >Save</v-btn
              >

               <v-btn v-if="replace"
                color=" darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save(true)"
                >Substituir O professor</v-btn
              >

            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
   </v-card>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    replace: false,
    disciplinas: [],
    disciplinasFiltered: [],
    ano: [],
    text: '',
    flag_curso: '',
    formValid: true,
    isLoading: true,
    turmasAll: [],
    turmasFiltered: [],
    search: '',
    cursos: [],
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    professores: [],
    profediscinas: [],
    dialog: false,
    headers: [
      {
        text: 'Quantidade de alunos',
        align: 'left',
        sortable: false,
        value: 'quantidade'
      },
      { text: 'Curso', value: 'descricao' },
      { text: 'Instituição', value: 'instituicao' },
      { text: 'Ano Lectivo', value: 'anoLectivo' }
    ],

    editedIndex: -1,
    editedItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      iddisciplina: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: '',
      classe: 0
    },
    defaultItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      iddisciplina: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: '',
      classe: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Atribuir Disciplina ao Professor' : 'Editar'
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.iniprofessores()
    this.initprofdisc()
    this.initAnoLectivo()
    this.initializeCursos()
    this.initializeturmasAll()
    this.initializedisciplinas()
  },

  methods: {
    async initAnoLectivo () {
      try {
        this.ano = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async initprofdisc (search) {
      this.isLoading = true
      let a = ls.get('anolectivo')
      if (this.editedItem.classe === 0) { console.log('oi') } else {
        a = this.editedItem.classe.descricao
        console.log('Classe: ' + a)
      }
      try {
        this.profediscinas = await axios
          .get('/quantidadeAlunosPorCurso/' + a)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
      console.log(this.profediscinas)
    },

    async iniprofessores (search) {
      try {
        if (!search) {
          var payload = '{"find":"all"}'
        } else {
          var payload = '{"find":"' + search + '"}'
        }
        this.professores = await axios
          .get('/professorFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializedisciplinas () {
      try {
        this.isLoading = true
        this.disciplinas = await axios
          .get('/disciplinaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    loadDiscpilanComb (turma) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.disciplinasFiltered = this.disciplinas.filter(t => t.idCurso === turma.idCurso && t.anoacademico === turma.idAno_Academico)
      this.$nextTick(() => { this.editedItem.iddisciplina = undefined })
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      const ls = require('local-storage')
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    editItem (item) {
      this.editedIndex = this.profediscinas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.profediscinas.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.profediscinas.splice(index, 1)
    },

    close () {
      this.replace = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save (replace) {
      var professordiscijaexiste = this.profediscinas.filter(
        p => p.iddisciplina === this.editedItem.iddisciplina.iddisciplina
      ) // if the id is not there then check for BI in collection before create new record if BI is in the collection. the entry already exist, if not insertOne

      if (!professordiscijaexiste.length > 0 || this.editedItem.idProfessorDisciTurma > 0 || replace === true) {
        this.saveprof()
      } else {
        this.replace = true
        this.$store.dispatch('textMessage', {
          msg: professordiscijaexiste[0].nome + ' é o professor que  lecciona  ' + this.editedItem.iddisciplina.descricao.toUpperCase() + ' na turma  ' + this.editedItem.turma.turmadescricao,
          classMessage: 'msgError',
          timeout: 7000
        })
      }
    },
    async saveprof () {
      const ls = require('local-storage')
      try {
        var params = {

          idProfessorDisciTurma: this.editedItem.idProfessorDisciTurma,
          idTurma: this.editedItem.turma.descricao,
          iddisciplina: this.editedItem.iddisciplina.iddisciplina,
          idProfessor: this.editedItem.professor.toString().split('-')[0],
          fkTurma: this.editedItem.turma.pkTurma,
          desciplinaDescricao: this.editedItem.iddisciplina.descricao

        }
      } catch (error) {
        console.log('---------------------------------------------------------' + error)
      }

      try {
        let msg = await axios
          .post('/professordisciInsertOrUpdate', params)
          .then(res => res.data)
          // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })

        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {}
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        let coll = {
          nome: this.editedItem.professor.toString().split('-')[1],
          descricao: this.editedItem.iddisciplina.descricao,
          turma: this.editedItem.turma.turmadescricao,
          periodo: this.editedItem.turma.periodo,
          curso: this.editedItem.turma.curso,
          anolectivo: this.editedItem.turma.anoLectivo
        }

        this.profediscinas.unshift(coll)

        this.close()
      }
    }
  }
}
</script>
